import React from 'react';

import { AdminProposalsTable } from 'src/components';

import classes from './adminProposals.module.scss';

export const AdminProposals = () => {
  return (
    <div className={classes.AdminProposals}>
      <AdminProposalsTable />
    </div>
  );
};
